import ResetPasswordPendingPage from "./ResetPasswordPendingPage";

export default ResetPasswordPendingPage;